module.exports = __webpack_public_path__ + "img/team-parcel-logo.8382bab0.png";